

// Extend
import base from '@/scripts/base';
import { mapState } from "vuex";
export default {
    extends: base,

    props: {
        // region: {
        //     type: Object,
        //     default: null
        // },
    },

    computed: {
        ...mapState({
            user: state => state.auth.user,
        }),
        applications() {
            try {
                return [
                    {
                        id: "iRenderDesktopApp",
                        name: "iRender GPU",
                        icon: "fas fa-desktop",
                        description: "This is a Application that helps you take data from the image’s C drive without booting the machine. It will save you more time and money.",
                        items: [
                            {
                                logo: "/logo/Windows_logo_-_2012.svg",
                                url: "https://gpuhubsync.s3.amazonaws.com/iRenderGPU/iRenderGPU_Setup.exe",
                                backupUrl: "",
                                label: "Download for Windows",
                                backupLabel: "Download backup link",
                                osVersion: "Windows 11/10/8.1/8/7 32/64-bit."
                            },
                            {
                                logo: "/logo/MacOS_logo.svg",
                                url: this.region !== 'VN' ? this.$CommonParameter.url.gpuhubSyncInternational_mac.value : this.$CommonParameter.url.gpuhubSyncVietnam_mac.value,
                                backupUrl: this.region !== 'VN' ? this.$CommonParameter.url.gpuhubSyncInternational_mac_onedrive.value : this.$CommonParameter.url.gpuhubSyncVietnam_mac_onedrive.value,
                                label: "Download for MacOS",
                                backupLabel: "Download backup link",
                                osVersion: "macOS Catalina or later."
                            },
                            {
                                logo: "/logo/Tux.svg",
                                url: this.region !== 'VN' ? this.$CommonParameter.url.gpuhubSyncInternational_linux.value : this.$CommonParameter.url.gpuhubSyncVietnam_linux.value,
                                backupUrl: this.region !== 'VN' ? this.$CommonParameter.url.gpuhubSyncInternational_linux_onedrive.value : this.$CommonParameter.url.gpuhubSyncVietnam_linux_onedrive.value,
                                label: "Download for Linux",
                                backupLabel: "Download backup link",
                                osVersion: "Ubuntu 18.04 or later."
                            }
                        ]
                    },
                    // {
                    //     id: "iRenderSyncData",
                    //     name: "iRender Sync Data",
                    //     icon: "el-icon-sort",
                    //     description: "This is a Application that helps you take data from the image’s C drive without booting the machine. It will save you more time and money.",
                    //     items: [
                    //         {
                    //             logo: "/logo/Windows_logo_-_2012.svg",
                    //             url: "https://gpuhubsync.s3.ap-southeast-1.amazonaws.com/GPUhub_Sync_QT_2.0/iRenderDriveSetup.exe",
                    //             backupUrl: "",
                    //             label: "Download for Windows",
                    //             backupLabel: "Download backup link",
                    //             osVersion: "Windows 11/10/8.1/8/7 32/64-bit."
                    //         }
                    //     ]
                    // },
                ];
            } catch {
                return [];
            }
        }
    },

    mounted() {
        this.region = this.user.region;
        this.$forceUpdate();
    },

    data() {
        return {
            region: '',
        }
    },

    methods: {

        //#region Close pop-up
        closeThisPopup() {
            this.closePopup("download");
        },
        //#endregion

        //#region Open Url
        openUrl(url) {
            window.open(url, '_blank')
        },
        //#endregion
    }
}